export default{
    reglas: [],
    reglaSelec: null,
}